<template>
  <v-container>
    {{ selectedItem }}
    <h4 class="text-center mt-3">Colores</h4>

    <h5 class="text-center mt-5">Background</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.background_color"
      @event="change_background_color"
    ></koiote-color-picker-vue>

    <h5 class="text-center mt-5">Foreground</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.foreground_color"
      @event="change_foreground_color"
    ></koiote-color-picker-vue>

    <h5 class="text-center mt-5">Borde</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.border_color"
      @event="change_border_color"
    ></koiote-color-picker-vue>

    <v-text-field
      prefix="Título:"
      class="ml-3 mr-3 mb-5"
      v-model="selectedItem.customized.label"
      @click="updateEditing(true)"
    ></v-text-field>

    <h4>Filas y columnas</h4>
    <v-row>
      <v-col cols="6">
        <v-text-field
          label="Filas"
          class="ml-3 mr-3 mb-5"
          v-model="filasCount"
          type="number"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Columnas"
          class="ml-3 mr-3 mb-5"
          v-model="columnasCount"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="6" class="text-center">
        <v-btn @click="generate(true)" block color="primary">Generar</v-btn>
      </v-col>
      <v-col cols="6" class="text-center">
        <v-btn @click="generate(false)" block color="primary">Abrir</v-btn>
      </v-col>
    </v-row>


    <!-- Modal -->
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="text-h6">Tabla Generada</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-for="(col, index) in columns" :key="'col-' + index">
                      <v-text-field
                          v-model="col.text"
                          label="Nombre"
                          dense
                      ></v-text-field>
                    </th>
                    <th>
                      <v-btn @click="addColumn" color="green">Agregar Columna</v-btn>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, rowIndex) in rows" :key="'row-' + rowIndex">
                    <td v-for="(col, colIndex) in columns" :key="'cell-' + rowIndex + '-' + colIndex" class="td-group">
                      <div class="cell-content">
                        <v-select
                          v-model="row[colIndex].tipo"
                          :items="[ { text: '-', value: 0 }, { text: 'static', value: 1 }, { text: 'mqtt', value: 2 }, { text: 'plc', value: 3 } ]"
                          item-text="text"
                          item-value="value"
                          label="Tipo"
                          dense
                        ></v-select>
                        <v-text-field
                          @change="dosubscribe(row[colIndex].topic)"
                          v-if="row[colIndex].tipo === 2 || row[colIndex].tipo === 3"
                          v-model="row[colIndex].topic"
                          label="Topic"
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-if="row[colIndex].tipo === 2 || row[colIndex].tipo === 3"
                          v-model="row[colIndex].name"
                          label="Name"
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-if="row[colIndex].tipo == 1"
                          v-model="row[colIndex].label"
                          label="Etiqueta"
                          dense
                        ></v-text-field>
                      </div>
                    </td>
                    <td>
                      <v-btn @click="removeRow(rowIndex)" color="red">Eliminar Fila</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- Botón para agregar fila -->
            <v-btn @click="addRow" color="blue" class="mt-3">Agregar Fila</v-btn>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import KoioteColorPickerVue from "@/components/utils/KoioteColorPicker.vue";

export default {
  name: "KoioteTablaProperties",
  components: {
    KoioteColorPickerVue,
  },
  data() {
    return {
      filasCount: 0,   // Número de filas, inicializado en 0
      columnasCount: 0, // Número de columnas, inicializado en 0
      rows: [],         // Arreglo de filas
      columns: [],      // Arreglo de columnas
      dialog: false,    // Controla la ventana modal
    };
  },
  computed: {
    ...mapState(["selectedItem"]),
    ...mapGetters(["actualPage"]),
    value() {
      return (
        this.actualPage()
          .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
          .customized.vartable.find((v) => v.formatted_address == this.selectedItem.customized.address)?.value || 0
      );
    },
  },
  methods: {
    ...mapActions(["updateEditing"]),
    ...mapActions("nodered",["dosubscribe"]),
    change_background_color(nc) {
      this.selectedItem.customized.background_color = nc;
    },
    change_foreground_color(nc) {
      this.selectedItem.customized.foreground_color = nc;
    },
    change_border_color(nc) {
      this.selectedItem.customized.border_color = nc;
    },

    generate(regenerar) {
      if (!regenerar) {
        // Si regenerar es falso, asignamos las filas y columnas desde selectedItem.customized.tabla
        if (this.selectedItem.customized.tabla) {
          this.rows = this.selectedItem.customized.tabla.rows;
          this.columns = this.selectedItem.customized.tabla.columns;
          this.dialog = true;
        } else {
          alert("No hay datos para mostrar.");
        }
        return;
      } 
      console.log(this.selectedItem.customized);
      if (this.filasCount > 0 && this.columnasCount > 0) {
        this.rows = [];
        this.columns = [];

        for (let i = 0; i < this.columnasCount; i++) {
          this.columns.push({ text: `Columna ${i + 1}` });
        }

        for (let i = 0; i < this.filasCount; i++) {
          let tempRow = [];
          for (let j = 0; j < this.columnasCount; j++) {
            const payload = {
              tipo: 0,
              topic: "",
              name: "",
            };
            tempRow.push(payload);
          }
          this.rows.push(tempRow);
        }

        // Guardar filas y columnas en selectedItem.customized.tabla
        this.selectedItem.customized.tabla = {
          rows: this.rows,
          columns: this.columns
        };

        this.dialog = true;
      } else {
        alert("Por favor, introduce un número válido de filas y columnas.");
      }
    },

    addColumn() {
      this.columns.push({ text: `Columna ${this.columns.length + 1}` });
      this.rows.forEach((row) => row.push({ tipo: 0, topic: "", name: "" }));

      // Actualizar en selectedItem.customized.tabla
      this.selectedItem.customized.tabla.columns = this.columns;
      this.selectedItem.customized.tabla.rows = this.rows;
    },

    removeRow(rowIndex) {
      this.rows.splice(rowIndex, 1);

      // Actualizar en selectedItem.customized.tabla
      this.selectedItem.customized.tabla.rows = this.rows;
    },

    // Método para agregar una nueva fila
    addRow() {
      let newRow = [];
      for (let i = 0; i < this.columns.length; i++) {
        newRow.push({ tipo: 0, topic: "", name: "" });
      }
      this.rows.push(newRow);

      // Actualizar en selectedItem.customized.tabla
      this.selectedItem.customized.tabla.rows = this.rows;
    },
  },

  mounted() {
    console.log(this.selectedItem)
    // Inicializar el objeto selectedItem
    this.filasCount=this.selectedItem.customized.tabla.rows.length;
    this.columnasCount=this.selectedItem.customized.tabla.columns.length;
  },
};
</script>

<style scoped>
.td-group {
  padding: 16px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  vertical-align: top;
}

.cell-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cell-content .v-select,
.cell-content .v-text-field {
  width: 100%;
}
</style>
